import _setTimeout from "@babel/runtime-corejs3/core-js-stable/set-timeout";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { useState } from 'react';
import { CurrencyInput } from '@eika/currency-input';
import './style.scss';
const UforekalkulatorInputField = _ref => {
  let {
    setValue,
    value
  } = _ref;
  const [delay, setDelay] = useState(null);
  const handleInput = e => {
    const inputIncome = e.target.value;
    if (delay) {
      clearTimeout(delay);
    }
    const newTimeout = _setTimeout(() => {
      setValue(inputIncome);
    }, 750);
    setDelay(newTimeout);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "salary"
  }, /*#__PURE__*/React.createElement(CurrencyInput, {
    name: "Inntekt",
    value: value,
    onChange: handleInput,
    maxLength: 11
  }));
};
export default UforekalkulatorInputField;